module.exports = __webpack_public_path__ + "img/MarathonInnova-text-logo.aa711a25.png";